import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';
import { Reveal } from '@/components/Reveal';

export default function PageHero({ eyebrow, title, subtitle, badge }) {
  return (
    <section className="relative overflow-hidden bg-brand-mist pb-14 pt-[120px] lg:pb-20 lg:pt-[160px]">
      <div className="grid-dots absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-brand-blue/15 blur-3xl" />
      <div className="container-x relative">
        {badge && (
          <Reveal>
            <span className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-white px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-blue">
              {badge}
            </span>
          </Reveal>
        )}
        <Reveal delay={0.05}>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-bold leading-[1.05] tracking-tight text-brand-navy sm:text-5xl lg:text-6xl">{title}</h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={0.12}>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-muted sm:text-lg">{subtitle}</p>
          </Reveal>
        )}
        {eyebrow && (
          <Reveal delay={0.18}>
            <Link to={eyebrow.href} data-testid={`pagehero-link-${eyebrow.label.toLowerCase().replace(/\s+/g, '-')}`} className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-brand-blue transition hover:gap-3">
              {eyebrow.label}
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}